import React from 'react';
import { observer } from 'mobx-react';
import SubuserDevicesComponent from './Subuser-devices.component';
import useSubuserDevices from './useSubuserDevices';
import { ICloseEvent } from '@core/interfaces/ICloseEvent';

const Container: React.FC<ICloseEvent> = ({ onClose }: ICloseEvent) => {
    const { subusers, devices, lang, state, handlers } =
        useSubuserDevices(onClose);

    return (
        <>
            <SubuserDevicesComponent
                lang={lang.lang}
                selectedSubuser={subusers.selectedSubuser}
                subusersDevices={subusers.subusersDevices}
                devices={devices.deviceList}
                serverError={subusers.serverError}
                deviceBtnHover={state.deviceBtnHover}
                deleteDeviceVisible={state.deleteDeviceVisible}
                editSubuserRightsVisible={state.editSubuserRightsVisible}
                onDeviceBtnHoverStart={handlers.handleDeviceBtnHoverStart}
                onDeviceBtnHoverStop={handlers.handleDeviceBtnHoverStop}
                onDeleteDeviceOpen={handlers.handleDeleteDeviceOpen}
                onDeleteDeviceClose={handlers.handleDeleteDeviceClose}
                onEditSubuserRightsOpen={handlers.handleEditSubuserRightsOpen}
                onEditSubuserRightsClose={handlers.handleEditSubuserRightsClose}
                onClose={onClose}
            />
        </>
    );
};

const SubuserDevicesContainer = observer(Container);

export default SubuserDevicesContainer;
